<!-- 分析进度到SQE节点+生态圈+物料 -->
<template>
  <h-list-page class="NAToSqeEcoSupplyMtl_style">
    <h-card :title="h_i18n('5148fcc0412bafcd98e04d4d183d8e18')" width="100%" is-search @change-method="changeMethod">
      <h-area>

        <h-search class="searchColItem" :title="h_i18n('2f0da6203964dcde2d14f089436bcef1')">
          <h-select v-model="searchData.searchFlag" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable filterable @change="changeNull(searchData.searchFlag, 'searchFlag') , changeSearchFlag()">
            <h-option :label="h_i18n('a183ab478599ca0af9963e479ef9bd74')" value="ecos"></h-option>
            <h-option :label="h_i18n('990e69c717662722fb8b111f67a9e229')" value="mtl"></h-option>
          </h-select>
        </h-search>

        <h-search class="searchColItem" :title="h_i18n('3c092f8c2f02bb3868b167e04275403f')">
          <h-select v-model="searchData.sqeNode" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" clearable filterable @change="changeNull(searchData.sqeNode, 'sqeNode')">
            <h-option v-for="item in data.sqeNodeList" :key="item.sqeNode" :label="item.sqeNode" :value="item.sqeNode"></h-option>
          </h-select>
        </h-search>

        <h-search class="searchColItem" :title="h_i18n('d9c8ae7c4e67140d3921659fa8664592')">
          <h-select v-model="searchData.ecosphere" clearable filterable @change="changeNull(searchData.ecosphere, 'ecosphere')">
            <h-option v-for="item in data.ecosphereList" :key="item.ecosphere" :label="item.ecosphere" :value="item.ecosphere">
            </h-option>
          </h-select>
        </h-search>

        <!-- <h-search class="searchColItem" title="供应商代码">
          <h-autocomplete popper-class="planHidden" v-model="searchData.supplyCode" :fetch-suggestions="supplyCodeChange"
            :trigger-on-focus="false" @input="() =>
                searchData.supplyCode.length < 2
                  ? (plan.showSupplyPlan = false)
                  : ''
              " @clear="plan.showSupplyPlan = false" clearable placeholder="请输入至少两位供应商代码"
            @blur="detailBlur('showSupplyPlan')" @focus="detailFocus('showSupplyPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0">
            <el-table v-show="plan.showSupplyPlan" v-loading="data.supplyLoading" :data="data.supplyCodeList" border
              size="small" max-height="252" @row-click="clickSupplierCode" @mousedown="plan.planBlur = true">
              <el-table-column prop="supplyCode" label="供应商代码" width="120"></el-table-column>
              <el-table-column prop="supplyName" label="供应商名称"></el-table-column>
            </el-table>
            <div v-if="plan.showSupplyPlan && plan.SupplyOver600" style="
                color: red;
                height: 20px;
                background-color: #fff;
                padding-top: 3px;
              ">
              <span style="padding-left: 10px; font-size: 12px">注：仅查询600条数据，如无所需结果，请输入更精确的供应商代码</span>
            </div>
          </h-detail>
        </h-search>
        <h-search class="searchColItem" title="供应商名称">
          <h-input v-model="searchData.supplyName" clearable @change="changeNull(searchData.supplyName, 'supplyName')">
          </h-input>
        </h-search> -->

        <h-search class="searchColItem" :title="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" v-if="data.typeName === 'NAToSqeEcoSupplyMtl'">
          <h-autocomplete popper-class="planHidden" v-model="searchData.mtlNo" :fetch-suggestions="mtlNoChange"
            :trigger-on-focus="false" @input="() =>
                searchData.mtlNo.length < 4 ? (plan.showMtlPlan = false) : ''
              " @clear="plan.showMtlPlan = false" clearable :placeholder="h_i18n('3bdbd9312d3a6f04ebdb6b99ac0f2f4a')" @blur="detailBlur('showMtlPlan')"
            @focus="detailFocus('showMtlPlan')">
          </h-autocomplete>
          <h-detail width="400px" top="34px" left="0px">
            <el-table v-show="plan.showMtlPlan" v-loading="data.mtlLoading" :data="data.mtlNoList" border size="small"
              max-height="252" @row-click="clickMtlNo" @mousedown="plan.planBlur = true">
              <el-table-column prop="mtlNo" :label="h_i18n('56ca9a2de6d54b00fb98ab39cce17089')" width="120"></el-table-column>
              <el-table-column prop="mtlName" :label="h_i18n('901fcadda8a5683e7a83a0c811ff4382')"></el-table-column>
            </el-table>
            <div v-if="plan.showMtlPlan && plan.MtlOver600" style="
                color: red;
                height: 20px;
                background-color: #fff;
                padding-top: 3px;
              ">
              <span style="padding-left: 10px; font-size: 12px">{{ h_i18n('a1fc8066cb705fef975d7db6b39eaa79') }}</span>
            </div>
          </h-detail>
        </h-search>
        <h-search class="searchColItem" :title="h_i18n('aae11e21d2ef24d030976e023bc44ff5')" v-if="data.typeName === 'NAToSqeEcoSupplyMtl'">
          <h-input v-model="searchData.mtlName" clearable @change="changeNull(searchData.mtlName, 'mtlName')">
          </h-input>
        </h-search>

        <h-search class="searchColItem" :title="h_i18n('9dfd1938d29d57fd38b6ff28b66f1688')">
          <h-date-picker v-model="searchTemp.year" type="year" format="YYYY"
                         @change="clearAll()"></h-date-picker>
        </h-search>

        <template #operate>
          <h-button type="primary" :loading="loading" @click="getInfo(true)" size="middle">{{ h_i18n('bee912d79eefb7335988c4997aa9138d') }}</h-button>
          <!-- <h-button type="default" :loading="loading" @click="handleReset" size="middle" style="margin-left: 12px;">
            重置
          </h-button> -->
        </template>

      </h-area>
    </h-card>

    <h-table-card :title="h_i18n('2a1ce69739af4f61e4765c926c4bc122')" :is-left="0" :h-data="data.dataOfTable">
      <template #buttonGroup>
        <h-button-group>
          <template v-for="item in data.btnListOfSqm" :key="item.code">
            <template v-for="temp in data.btnCodeList" :key="temp">
              <h-button v-if="item.code.includes(temp)" type="primary"
               :loading="loadingFunction(temp)" @click="btnFunction(temp)">
                <export v-if="temp == 'mkhl_fxjd_mtl_DC'"/>
                {{ item.name }}</h-button>
            </template>
          </template>
        </h-button-group>
      </template>

      <el-table :empty-text="h_i18n('8fd727180609a8164afad4b5eecc5544')" class="forPic_table_style" v-loading="data.tableLoading" height="500" @selection-change="listCheckBoxChange"
      border :data="data.dataOfTable" size="small" style="width: 100%; min-height: 500px">
        <el-table-column type="index" :label="h_i18n('faaadc447b1c2b1adc920d9c9aedcc25')" :width="data.tableWidth_A"></el-table-column>
        <el-table-column prop="sqeNode" :label="h_i18n('3c092f8c2f02bb3868b167e04275403f')" :min-width="data.tableWidthA"></el-table-column>
        <el-table-column prop="ecosphere" :label="h_i18n('d9c8ae7c4e67140d3921659fa8664592')" :min-width="data.tableWidthB"></el-table-column>
        <el-table-column prop="supplyCode" :label="h_i18n('1b7ecd2bdbd8a1a112dead57724f06df')" :min-width="data.tableWidthA"></el-table-column>
        <el-table-column prop="supplyName" :label="h_i18n('9190cc22c9ba377113bc54ac51013a0b')" :min-width="data.tableWidthE"></el-table-column>
        <el-table-column prop="mtlNo" :label="h_i18n('f1edca9f040d256cee01ef89fa5499f0')" :min-width="data.tableWidthC" v-if="data.typeName === 'NAToSqeEcoSupplyMtl'"></el-table-column>
        <el-table-column prop="mtlName" :label="h_i18n('aae11e21d2ef24d030976e023bc44ff5')" :min-width="data.tableWidthE" v-if="data.typeName === 'NAToSqeEcoSupplyMtl'"></el-table-column>
        <el-table-column prop="year" :label="h_i18n('9dfd1938d29d57fd38b6ff28b66f1688')" :width="data.tableWidth_Aa" class-name="number_cell"></el-table-column>
        <el-table-column prop="yearRreturnNum" :label="h_i18n('8b4eab304cfdc2bb6e32f714540a05a4')" :min-width="data.tableWidthC" class-name="number_cell">
          <!-- el-table header插槽 -->
          <template #header>
            <span>{{ h_i18n('8b4eab304cfdc2bb6e32f714540a05a4') }}<el-tooltip class="item" effect="dark" :content="h_i18n('45e0c690bd56761de120b6969edeae17')" placement="top-start">
                <help theme="outline" size="14" class="blueColor" style="display: inline-block; position: relative;top: 2px;"/>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="actualAnalysisNum" :label="h_i18n('eea26846fbc039def2c6f31484f85758')" :min-width="data.tableWidthC" class-name="number_cell">
          <template #header>
            <span>{{ h_i18n('eea26846fbc039def2c6f31484f85758') }}<el-tooltip class="item" effect="dark" :content="h_i18n('a05de3d4af9c5124937383bb8e408149')" placement="top-start">
                <help theme="outline" size="14" class="blueColor" style="display: inline-block; position: relative;top: 2px;"/>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="analysisRate" :label="h_i18n('2f05caae628f8820658b24fc12332437')" :min-width="data.tableWidth_Aa" class-name="number_cell"></el-table-column>
        <el-table-column prop="thisYearClaimNum" :label="h_i18n('0a43bc992d5436e83a0599429af999da')" :min-width="data.tableWidthF" class-name="number_cell">
          <template #header>
            <span>{{ h_i18n('0a43bc992d5436e83a0599429af999da') }}<el-tooltip class="item" effect="dark" :content="h_i18n('9dff7f7e1448934f47c0ef23b6759b65')" placement="top-start">
                <help theme="outline" size="14" class="blueColor" style="display: inline-block; position: relative;top: 2px;"/>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="shouldRenZeNum" :label="h_i18n('e142a3d20c0a617947f11fdf5bcc98a8')" :min-width="data.tableWidthD" class-name="number_cell">
          <template #header>
            <span>{{ h_i18n('e142a3d20c0a617947f11fdf5bcc98a8') }}<el-tooltip class="item" effect="dark" :content="h_i18n('9d3e91cf238e2469d3c8cbde4bab5b84')" placement="top-start">
                <help theme="outline" size="14" class="blueColor" style="display: inline-block; position: relative;top: 2px;"/>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="actualdRenZeNum" :label="h_i18n('08105135166f6f2452cd3bbebe4327ff')" :min-width="data.tableWidthD" class-name="number_cell">
          <template #header>
            <span>{{ h_i18n('08105135166f6f2452cd3bbebe4327ff') }}<el-tooltip class="item" effect="dark" :content="h_i18n('1733984ebab9bf665baba47b4ddbe2b2')" placement="top-start">
                <help theme="outline" size="14" class="blueColor" style="display: inline-block; position: relative;top: 2px;"/>
              </el-tooltip>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="cha" :label="h_i18n('951cf15a11869fe099a0474175721eab')" :min-width="data.tableWidthA" class-name="number_cell">
          <template #default="{ row }">
            <!-- <span style="color: #2164f5; cursor: pointer; text-overflow: ellipsis; overflow: hidden; display: block" @click="openDetail(row)"> -->
              {{ row.cha }}
            <!-- </span> -->
          </template>
        </el-table-column>
        <el-table-column prop="completeRate" :label="h_i18n('1724cf75f2f6c4b0556f7bae06414aa1')" :min-width="data.tableWidthA" class-name="number_cell"></el-table-column>
      </el-table>
      <el-pagination background @size-change="handleSizeChange" @current-change="getInfo"
        v-model:currentPage="searchData.pageNo" :page-size="10" layout="total, prev, pager, next,jumper"
        :total="data.total">
      </el-pagination>
    </h-table-card>
  </h-list-page>
  <!-- 弹窗 -->
  <!-- <h-dialog class="dialog_style" title="详情" :show="data.dialogShow" width="90%" @close="data.dialogShow = false">
    <template #rightButton>
    </template>
    <NAOfDetail :rowData="data.rowData" :dialogShow="data.dialogShow"></NAOfDetail>
  </h-dialog> -->
</template>

<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated, ref } from 'vue';
import { useRoute } from 'vue-router';
import NodeAnalysisApi from './api'
import axios from "axios";
// import NAOfDetail from './NAOfDetail'
const { proxy, ctx } = getCurrentInstance();
const route = useRoute();
const searchData = reactive({
  pageNo: 1,
  pageSize: 10,
  searchFlag: 'ecos',
  supplyCode:'',
  mtlNo:'',
});
const searchTemp = reactive({})
const data = reactive({
  exportBtnCodeOfHac:'DC', // 导出
  tableWidth_A : '48',
  tableWidth_Aa : '68',
  tableWidthA : '88',
  tableWidthB : '98',
  tableWidthC : '128',
  tableWidthD : '148',
  tableWidthE : '168',
  tableWidthF : '188',
  dialogTotal:0,
  total:0,
  buttonList:[],
  dataOfDialogTable:[],
  dialogShow:false,
  rowData:{},
  exportLoading:false,
  mtlLoading:false,
  supplyLoading:false,
  btnCodeList:[
    "mkhl_fxjd_mtl_DC"
  ],
  btnListOfSqm:[],
  typeName : 'NAToSqeEco',
})
// 重置
const handleReset = () =>{
  searchData.supplyCode = ''
  searchData.supplyName = ''
  searchData.sqeNode = ''
  searchData.ecosphere = ''
  searchData.mtlNo = ''
  searchData.mtlName = ''
  searchTemp.year = new Date()
  searchData.year = searchTemp.year.getFullYear()
}
// 按钮事件
const btnFunction = (btnCode) => {
  switch(btnCode){
    case "mkhl_fxjd_mtl_DC": // 导出
      excleBtn()
      break;
    default:
      return null;
  }
}
// loading事件
const loadingFunction = (btnCode) => {
  switch(btnCode){
    case "mkhl_fxjd_mtl_DC":
      return data.exportLoading
    default:
      return null;
  }
}
// input为空时undefined
const changeNull = (value, key) => {
  if (value === "") {
    searchData[key] = undefined;
  }
};
// 切换统计维度
const changeSearchFlag = () => {
  switch (searchData.searchFlag){
    case 'ecos':
      data.typeName = 'NAToSqeEco'
      searchData.mtlNo = ''
      searchData.mtlName = ''
      data.dataOfTable = []
      break
    case 'mtl':
      data.typeName = 'NAToSqeEcoSupplyMtl'
      data.dataOfTable = []
      break
    default :
      searchData.searchFlag = 'ecos'
      data.typeName = 'NAToSqeEco'
      searchData.mtlNo = ''
      searchData.mtlName = ''
      data.dataOfTable = []
  }
}
// 两个模糊查询 开始
const http = reactive({
  mtlSearchHttp: false,
  supplySearchHttp: false,
});
const plan = reactive({
  showMtlPlan: false,
  planBlur: false,
  showSupplyPlan: false,
  MtlOver600: false,
  SupplyOver600: false,
});

// 弹窗失焦
const detailBlur = (v) => {
  if (!plan.planBlur) {
    plan[v] = false;
  }
};
// 弹窗聚焦
const detailFocus = (v) => {
  plan.planBlur = false;
  if (v == "showSupplyPlan") {
    if (searchData.supplyCode.length >= 2) {
      plan[v] = true;
    }
  } else if (v == "showMtlPlan") {
    if (searchData.mtlNo.length >= 4) {
      plan[v] = true;
    }
  }
};
const clickMtlNo = (row) => {
  searchData.mtlNo = row.mtlNo;
  plan.showMtlPlan = false;
};

const clickSupplierCode = (row) => {
  searchData.supplyCode = row.supplyCode;
  plan.showSupplyPlan = false;
};
/**
 * 专用号模糊查询
 */
const mtlNoChange = () => {
  plan.planBlur = false;
  if (http.mtlSearchHttp) http.mtlSearchHttp.cancel();
  http.mtlSearchHttp = axios.CancelToken.source();
  if (searchData.mtlNo.length < 4) {
    plan.showMtlPlan = false;
  } else {
    plan.showMtlPlan = true;
    data.mtlLoading = true;
    let promise = NodeAnalysisApi.apiMtlNoChange(proxy,{mtlNo:searchData.mtlNo},http.mtlSearchHttp.token)
    promise.then((res) => {
      data.mtlNoList = res.data.data;
      if (data.mtlNoList.length >= 600) {
        plan.MtlOver600 = true;
        data.mtlLoading = false;
      } else {
        plan.MtlOver600 = false;
        data.mtlLoading = false;
      }
    }).catch((e) => { 
    }).finally(()=>{
    })
  }
};
/**
 * 供应商模糊查询
 */
const supplyCodeChange = () => {
  plan.planBlur = false;
  if (http.supplySearchHttp) http.supplySearchHttp.cancel();
  http.supplySearchHttp = axios.CancelToken.source();
  if (searchData.supplyCode.length < 2) {
    plan.showSupplyPlan = false;
  } else {
    plan.showSupplyPlan = true;
    data.supplyLoading = true;
    let promise = NodeAnalysisApi.apiSupplyCodeChange(proxy,{supplyCode:searchData.supplyCode},http.mtlSearchHttp.token)
    promise.then((res) => {
      data.supplyCodeList = res.data.data;
      if (data.supplyCodeList.length >= 600) {
        plan.SupplyOver600 = true;
        data.supplyLoading = false;
      } else {
        plan.SupplyOver600 = false;
        data.supplyLoading = false;
      }
    }).catch((e) => { 
    }).finally(()=>{
    })
  }
};
// 两个模糊查询 结束
/**
 * 年月 空检验
 */
 const clearAll = (flag) => {
  if (!searchTemp.year) {
    // !flag && proxy.$message({
    //   message: '年 不允许为空',
    //   type: 'warning',
    // })
    searchData.year = undefined
  } else {
    date(searchTemp.year, "year");
  }
  if (!searchTemp.month) {
    // !flag && proxy.$message({
    //   message: '月 不允许为空',
    //   type: 'warning',
    // })
    searchData.month = undefined
  } else {
    date(searchTemp.month, "month");
  }
}
/**
 * 上传前时间处理,转录
 * @param year 年
 * @param month 月
 */
 const date = (date, type) => {
  if (type === "year") {
    searchData.year = new Date(date).getFullYear();
  } else if (type === "month") {
    searchData.month =
      new Date(date).getMonth() + 1 < 10
        ? new Date(date).getMonth() + 1
        : new Date(date).getMonth() + 1;
  }
}
// sqe节点
const apiSqeNodeList = () =>{
  let promise = NodeAnalysisApi.getSqeNodeList(proxy)
  promise.then(res=>{
    if (res.data.code === '200') {
      let sqeNodeListTemp = res.data.data.records.map(item=>{
        return {sqeNode:item.sqeNode}
      })
      data.sqeNodeList = sqeNodeListTemp.filter((obj, index, self) =>
        index === self.findIndex((t) => (
          t.sqeNode === obj.sqeNode
        ))
      )
    } else {

    }
  }).catch(err=>{

  }).finally(()=>{

  })
}
// 生态圈列表
const apiEcoList = () => {
  let promise = NodeAnalysisApi.getSqeNodeList(proxy)
  promise.then((res) => {
    if(res.data.code === '200'){
      data.ecosphereList = res.data.data.records.map(item=>{
        return {ecosphere:item.ecosphere,id:item.id}
      })
    }else{
    }
  })
  .catch((err) => {
  })
  .finally(() => {
  });
}
/**详情部分 */
const openDetail = (row) => {
  let rowData = {
    year:row.year,
    supplyCode:row.supplyCode,
    supplyName:row.supplyName,
    mtlNo:row.mtlNo,
    mtlName:row.mtlName,
    ecosphere:row.ecosphere,
    sqeNode:row.sqeNode,
  }
  data.rowData = rowData
  data.dialogShow = true
}
/** 详情部分结束 */

const getInfo = () => {
  proxy.startLoading(h_i18n('4ea9bfb770e5e7e1de0533b273c686fb'));
  let promise = NodeAnalysisApi.getInfo(proxy,searchData)
  promise.then(res=>{
    if(res.data.code === '200'){
      data.dataOfTable = res.data.data.records
      data.total = res.data.data.total
    }else{
      console.log('失败：',res.data.msg)
    }
  }).catch(err=>{

  }).finally(()=>{
    proxy.closeLoading()
  })
}
const excleBtn = () => {
  if (data.total > 5000) {
    proxy.warning({
      message: h_i18n('5d11f64ddbaa899949fcdecee0185f2d'),
      title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => {},
    });
    return;
  }
  if (data.total < 1) {
    proxy.warning({
      message: h_i18n('f59ec2b6c282f2c37663f524c2a318c3'),
      title: h_i18n('f148292ae0c683ca6fe4246350d309f6'),
      confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
      callback: (action) => {},
    });
    return;
  }
  data.exportLoading = true;
  proxy.startLoading(h_i18n('652f8289bcda82f71c267cd7bf24b240'));
  let promise = NodeAnalysisApi.getExcel(proxy,searchData,h_i18n('469450a40ea6f15d09bdaa9160e85324'))
  promise.then(res=>{
  }).catch(err=>{

  }).finally(()=>{
    data.exportLoading = false;
    proxy.closeLoading()
  })
}
onMounted(()=>{
  if(route.query){
    searchData.supplyCode = route.query.supplyCode;
  }
  // sqm按钮权限
  if(route.query.parentId && route.query.parentId != 'null' && route.query.parentId != 'undefined' && route.query.parentId != ''){
    let p = proxy.getButtonFromSqm(route.query.parentId,route.query.roleCode)
    p.then(res=>{
      if(res.length > 0){
        data.btnListOfSqm = res
      }
    })
  }
  searchTemp.year = new Date();
  date(searchTemp.year,'year')
  apiSqeNodeList()
  apiEcoList()
  // getInfo()
})
</script>

<style lang="scss">
.NAToSqeEcoSupplyMtl_style{
  .el-table .cell{
    text-align: left;
  }
  .el-table {
    .number_cell .cell {
      text-align: right;
    }
    tbody .number_cell .cell {
      padding-right: 6px !important;
    }
  }
}
.dialog_style .haier-dialog {
  top: 1%;
}
.planHidden {
  display: none;
}
</style>